export enum DevicePushState {
  /**
   * soft ask triggered, user accepted, notification permission granted
   */
  SENT = 'SENT',
  /**
   * default initial state, soft ask not triggered
   */
  NOT_SENT = 'NOT_SENT',
  /**
   * user disabled manually in account settings
   */
  DISABLED = 'DISABLED',
  /**
   * blocked on browser level or not supported
   */
  BLOCKED = 'BLOCKED',
}
